import React, { Component } from "react";
import { message, PageHeader, Spin, Row, Col, Tooltip, Form as FormInitial, Tag, Select, Space } from "antd";
import { ArrowLeftOutlined, CalculatorOutlined, ArrowUpOutlined, WarningOutlined, FireOutlined, DownOutlined, RightOutlined, ToolOutlined, InboxOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  ButtonItem,
  ErrorItem,
  MensajeError,
  TextAreaItem,
  SwitchItem,
  round2Decimals,
} from "../../../../Components/Items";
import { iconoDeEtapa, colorDeEtapa } from "../../PresupuestosPU/EtapasOrdenProduccionPU/etapaVisual.utils";
import SelectProyectosItem from "../../../../Components/SelectProyectosItem";

const { Option } = Select;

const aplanarHojas = (nodos, origen) => {
  const resultado = [];
  for (const nodo of nodos || []) {
    if (nodo.esMatriz) {
      resultado.push(...aplanarHojas(nodo.children, { clave: nodo.clave, descripcion: nodo.descripcion }));
    } else {
      resultado.push(origen ? { ...nodo, matrizOrigenClave: origen.clave, matrizOrigenDescripcion: origen.descripcion } : nodo);
    }
  }
  return resultado;
};

class RequerirMaterialOrden extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    orden: null,
    insumos: [],
    colapsados: [],
  };

  get ordenId() {
    return this.props.location?.state?.ordenId;
  }

  get matrizId() {
    return this.props.location?.state?.matrizId;
  }

  get etapaId() {
    return this.props.location?.state?.etapaId;
  }

  get piezasElegidas() {
    return this.props.location?.state?.piezasElegidas;
  }

  componentDidMount() {
    this.consultarDetalle();
  }

  consultarDetalle = () => {
    this.setState({ loading: true });
    axios
      .post("almacen/detalleInsumosOrden", { ordenId: this.ordenId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          return MensajeError({ message: res.data.error || "No se pudo cargar el detalle de la orden" });
        }

        const resumenPorInsumoId = new Map((res.data.insumos || []).map((insumo) => [insumo.insumoId, insumo]));
        const esAbierta = res.data.orden?.tipoLista === "abierta";
        const matrices = (res.data.matrices || []).filter((matriz) => {
          if (this.matrizId && matriz.matrizId !== this.matrizId) return false;
          if (this.etapaId && matriz.etapaId !== this.etapaId) return false;
          return true;
        });

        const insumosPendientes = matrices.flatMap((matriz) => {
          const escalar = this.piezasElegidas != null && matriz.piezasEtapa > 0 && this.piezasElegidas < matriz.piezasEtapa;

          return aplanarHojas(matriz.insumos)
            .filter((insumo) => esAbierta || insumo.pendiente > 0)
            .map((insumo) => {
              const resumen = resumenPorInsumoId.get(insumo.insumoId);
              const sugeridoPiezas =
                escalar && !insumo.fueraDeLista
                  ? Math.min(
                      round2Decimals((insumo.cantidadPorUnidad || 0) * this.piezasElegidas),
                      esAbierta ? Infinity : insumo.pendiente
                    )
                  : null;
              return {
                ...insumo,
                grupoId: matriz.grupoId,
                matrizId: matriz.matrizId,
                etapaId: matriz.etapaId,
                matrizClave: matriz.clave,
                matrizDescripcion: matriz.descripcion,
                matrizEtapa: matriz.etapa,
                necesarioTotal: insumo.necesario,
                sugeridoPiezas,
                faltante: resumen?.faltante || 0,
                inventarioDisponible: resumen?.inventarioDisponible,
                inventarioDisponibleOrigen: resumen?.inventarioDisponibleOrigen,
                fueraDeLista: insumo.fueraDeLista,
              };
            });
        });

        this.setState({ orden: res.data.orden, insumos: insumosPendientes });
        this.formRef.current.setFieldsValue({
          insumos: insumosPendientes.map((insumo) => ({ ...insumo, requerir: insumo.sugeridoPiezas ?? insumo.pendiente })),
          proyectoOrigenId: res.data.orden?.proyectoOrigenId?._id || res.data.orden?.proyectoOrigenId,
          proyectoEjecucionId: res.data.orden?.proyectoEjecucionId?._id || res.data.orden?.proyectoEjecucionId,
        });

        const folio = res.data.orden?.folio;
        let observaciones = folio ? `Surtir material de la Orden ${folio}` : "";
        if (matrices.length === 1) {
          const matrizUnica = matrices[0];
          const nombreMatriz = `${matrizUnica.clave ? matrizUnica.clave + " - " : ""}${matrizUnica.descripcion}`;
          const sufijoPiezas =
            this.piezasElegidas != null && this.piezasElegidas < matrizUnica.piezasEtapa
              ? ` (${this.piezasElegidas} de ${matrizUnica.piezasEtapa} pza)`
              : "";
          observaciones = matrizUnica.etapa
            ? `Surtir etapa "${matrizUnica.etapa.nombre}" (${nombreMatriz}) de la Orden ${folio}${sufijoPiezas}`
            : `Surtir matriz ${nombreMatriz} de la Orden ${folio}${sufijoPiezas}`;
        }
        this.formRef.current.setFieldsValue({ observaciones });
      })
      .catch(() => this.setState({ loading: false }));
  };

  onFinishFailed = (e) => ErrorItem(e);

  onFinish = (values) => {
    const insumosARequerir = (values.insumos || [])
      .filter((insumo) => insumo.requerir > 0)
      .map((insumo) => ({
        insumoId: insumo.insumoId,
        cantidad: insumo.requerir,
        matrizId: insumo.fueraDeLista ? undefined : insumo.matrizId,
        etapaId: insumo.fueraDeLista ? undefined : insumo.etapaId,
      }));

    if (insumosARequerir.length === 0) {
      return message.info("Pon cantidades para poder requerir material");
    }

    this.setState({ loading: true });
    axios
      .post(
        "almacen/requerirMaterialOrden",
        {
          empresaId: this.props.empresaId,
          ordenId: this.ordenId,
          insumos: insumosARequerir,
          proyectoId: values.proyectoOrigenId,
          fechaEntrega: values.fechaEntrega,
          observaciones: values.observaciones,
          importancia: values.importancia,
          separarInsumos: values.separarInsumos,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha generado la requisición número " + res.data.numeroRequisicion);
          this.props.history.goBack();
        } else {
          MensajeError({ message: res.data.error || "No se pudo requerir el material" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  clamp = (valor, fieldKey) => {
    const pendiente = this.state.insumos[fieldKey]?.pendiente || 0;
    const esAbierta = this.state.orden?.tipoLista === "abierta";
    return esAbierta ? valor : Math.min(valor, pendiente);
  };

  aplicarA = (campo, filtro) => {
    const insumos = this.formRef.current.getFieldValue("insumos") || [];
    const nuevos = insumos.map((insumo, index) => {
      if (filtro && !filtro(this.state.insumos[index], index)) return insumo;
      return { ...insumo, requerir: this.clamp(this.state.insumos[index]?.[campo] || 0, index) };
    });
    this.formRef.current.setFieldsValue({ insumos: nuevos });
  };

  requerirUno = (fieldKey, campo) => {
    const insumos = this.formRef.current.getFieldValue("insumos") || [];
    const nuevos = [...insumos];
    nuevos[fieldKey] = { ...nuevos[fieldKey], requerir: this.clamp(this.state.insumos[fieldKey]?.[campo] || 0, fieldKey) };
    this.formRef.current.setFieldsValue({ insumos: nuevos });
  };

  requerirTodo = (campo) => this.aplicarA(campo);
  requerirGrupo = (grupoId, campo) => this.aplicarA(campo, (insumo) => insumo?.grupoId === grupoId);

  onToggleGrupo = (grupoId) => {
    this.setState((prev) => ({
      colapsados: prev.colapsados.includes(grupoId) ? prev.colapsados.filter((id) => id !== grupoId) : [...prev.colapsados, grupoId],
    }));
  };

  renderCalculadoras(onClick) {
    return (
      <>
        <Tooltip title="Requerir el faltante (vs. inventario)">
          <CalculatorOutlined onClick={() => onClick("faltante")} style={{ marginLeft: 5, color: "#cf1322" }} />
        </Tooltip>
        <Tooltip title="Requerir el pendiente">
          <CalculatorOutlined onClick={() => onClick("pendiente")} style={{ marginLeft: 5, color: "#2d929e" }} />
        </Tooltip>
        <Tooltip title="Requerir el total necesario">
          <CalculatorOutlined onClick={() => onClick("necesarioTotal")} style={{ marginLeft: 5, color: "#efb300" }} />
        </Tooltip>
      </>
    );
  }

  renderEtapaTag(etapa) {
    if (!etapa) return null;
    const color = colorDeEtapa(etapa);
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 4,
          border: `1.5px solid ${color}`,
          backgroundColor: "#fff",
          borderRadius: 999,
          padding: "0 8px",
          height: 22,
          lineHeight: "19px",
          fontSize: 12,
          color: "#000",
        }}
      >
        <span style={{ color, display: "flex" }}>{iconoDeEtapa(etapa)}</span>
        {etapa.nombre}
      </span>
    );
  }

  render() {
    const { orden, insumos, loading, colapsados } = this.state;
    const esAbierta = orden?.tipoLista === "abierta";

    return (
      <Spin spinning={loading}>
        <PageHeader
          onBack={() => this.props.history.goBack()}
          backIcon={<ArrowLeftOutlined />}
          title={orden ? `Requerir material: Orden ${orden.folio}` : "Requerir material"}
          tags={
            orden && (
              <Tag color={esAbierta ? "green" : "default"}>
                Lista {esAbierta ? "abierta: se puede pedir de más" : "cerrada: tope al pendiente"}
              </Tag>
            )
          }
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
        />

        <div style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" }}>
          <Form
            ref={this.formRef}
            name="RequerirMaterialOrden"
            layout
            bottom={
              <ButtonItem mostaza htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
                Requerir material
              </ButtonItem>
            }
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
          >
            <Row gutter={16} style={{ marginBottom: 16 }}>
              <Col span={12}>
                <FormItem
                  label={<span><InboxOutlined style={{ color: "#52c41a", marginRight: 4 }} />Proyecto de Origen (bodega)</span>}
                  name="proyectoOrigenId"
                  required
                  margin
                  tooltip="A dónde llega la compra. El almacenista la traspasa después al proyecto de producción."
                >
                  <SelectProyectosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} placeholder="Proyecto de origen / bodega" />
                </FormItem>
              </Col>
              <Col span={12}>
                <FormItem
                  label={<span><ToolOutlined style={{ color: "#1890ff", marginRight: 4 }} />Proyecto de Producción</span>}
                  name="proyectoEjecucionId"
                  margin
                  tooltip="Dónde se consume el material (informativo, viene de la orden)."
                >
                  <SelectProyectosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} placeholder="Proyecto de producción" />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={16} style={{ marginBottom: 16 }}>
              <Col span={8}>
                <FormItem label="Fecha de entrega" name="fechaEntrega" required margin initialValue={moment()}>
                  <DatePickerItem placeholder="Fecha de entrega" allowClear={false} />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem label="Importancia" name="importancia" margin initialValue={2} tooltip="Nivel de importancia: 1 = Baja, 2 = Media, 3 = Alta">
                  <SelectItem placeholder="Nivel de importancia">
                    <Option value={1}><Tag color="green"><ArrowUpOutlined /> Baja</Tag></Option>
                    <Option value={2}><Tag color="orange"><WarningOutlined /> Media</Tag></Option>
                    <Option value={3}><Tag color="red"><FireOutlined /> Alta</Tag></Option>
                  </SelectItem>
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem label="Separar insumos" name="separarInsumos" margin initialValue={true} valuePropName="checked">
                  <SwitchItem />
                </FormItem>
              </Col>
              <Col span={24}>
                <FormItem label="Observaciones" name="observaciones" margin pattern>
                  <TextAreaItem placeholder="Observaciones" />
                </FormItem>
              </Col>
            </Row>

            <FormInitial.List name="insumos">
              {(fields) => (
                <div style={{ overflowX: "auto" }}>
                  <table className="table">
                    {fields.length > 0 && (
                      <thead>
                        <tr>
                          <th className="th-border">Insumo</th>
                          <th className="th-border" style={{ width: "9%" }}>Necesario</th>
                          <th className="th-border" style={{ width: "9%" }}>Ya requisitado</th>
                          <th className="th-border" style={{ width: "9%" }}>Pendiente</th>
                          <th className="th-border" style={{ width: "10%" }}>Inv. producción</th>
                          <th className="th-border" style={{ width: "10%" }}>Inv. origen</th>
                          <th className="th-border" style={{ width: "18%" }}>
                            Cantidad a requerir
                            {this.renderCalculadoras((campo) => this.requerirTodo(campo))}
                          </th>
                        </tr>
                      </thead>
                    )}
                    <tbody>
                      {fields.map(({ key, name, fieldKey, ...restField }, arrayKey) => {
                        const insumo = insumos[arrayKey];
                        const cambiaGrupo = arrayKey === 0 || insumos[arrayKey - 1]?.grupoId !== insumo?.grupoId;
                        const colapsado = insumo && colapsados.includes(insumo.grupoId);
                        const acento = colorDeEtapa(insumo?.matrizEtapa);
                        return (
                          <React.Fragment key={fieldKey}>
                            {cambiaGrupo && insumo && (
                              <tr>
                                <td
                                  colSpan={7}
                                  style={{ borderLeft: `4px solid ${acento}`, padding: "8px 12px", background: "#fafafa", cursor: "pointer" }}
                                  onClick={() => this.onToggleGrupo(insumo.grupoId)}
                                >
                                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
                                    <Space size={10}>
                                      {colapsados.includes(insumo.grupoId) ? (
                                        <RightOutlined style={{ fontSize: 11, color: "#999" }} />
                                      ) : (
                                        <DownOutlined style={{ fontSize: 11, color: "#999" }} />
                                      )}
                                      <span style={{ fontWeight: 700, color: "#333" }}>
                                        {insumo.matrizClave ? insumo.matrizClave + " - " : ""}
                                        {insumo.matrizDescripcion}
                                      </span>
                                      {this.renderEtapaTag(insumo.matrizEtapa)}
                                    </Space>
                                    <span onClick={(e) => e.stopPropagation()}>
                                      {this.renderCalculadoras((campo) => this.requerirGrupo(insumo.grupoId, campo))}
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            )}
                            <tr style={colapsado ? { display: "none" } : undefined}>
                              <td className="td-border">
                                {insumos[arrayKey]?.clave ? insumos[arrayKey].clave + " - " : ""}
                                {insumos[arrayKey]?.descripcion}
                                {insumos[arrayKey]?.fueraDeLista && (
                                  <Tag color="gold" style={{ marginLeft: 6 }}>
                                    Fuera de lista
                                  </Tag>
                                )}
                                {insumos[arrayKey]?.matrizOrigenDescripcion && (
                                  <div style={{ fontSize: 11, color: "#999" }}>
                                    de: {insumos[arrayKey].matrizOrigenClave ? insumos[arrayKey].matrizOrigenClave + " - " : ""}
                                    {insumos[arrayKey].matrizOrigenDescripcion}
                                  </div>
                                )}
                              </td>
                              <td className="td-border">
                                {insumos[arrayKey]?.necesarioTotal}
                                {insumos[arrayKey]?.extra > 0 && !insumos[arrayKey]?.fueraDeLista && (
                                  <div style={{ fontSize: 11, color: "#ad8b00" }}>+{insumos[arrayKey].extra} extra</div>
                                )}
                              </td>
                              <td className="td-border">{insumos[arrayKey]?.yaRequisitado}</td>
                              <td className="td-border">{insumos[arrayKey]?.pendiente}</td>
                              <td className="td-border">{insumos[arrayKey]?.inventarioDisponible ?? "—"}</td>
                              <td className="td-border">
                                {insumos[arrayKey]?.inventarioDisponibleOrigen === null || insumos[arrayKey]?.inventarioDisponibleOrigen === undefined
                                  ? "—"
                                  : insumos[arrayKey].inventarioDisponibleOrigen}
                              </td>
                              <td className="td-border">
                                <Row>
                                  <Col span={13}>
                                    <FormItem
                                      {...restField}
                                      name={[name, "requerir"]}
                                      fieldKey={[fieldKey, "requerir"]}
                                      noStyle
                                      numberCero
                                      type="number"
                                      max={esAbierta ? undefined : insumos[arrayKey]?.pendiente}
                                    >
                                      <InputNumberItem
                                        sinBorde
                                        placeholder={esAbierta ? "Cantidad" : "Max: " + insumos[arrayKey]?.pendiente}
                                        style={!esAbierta ? { backgroundColor: "#f5f5f5" } : undefined}
                                      />
                                    </FormItem>
                                  </Col>
                                  <Col span={11}>{this.renderCalculadoras((campo) => this.requerirUno(arrayKey, campo))}</Col>
                                </Row>
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </FormInitial.List>
          </Form>
        </div>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(RequerirMaterialOrden);
